export default "__VITE_ASSET__7f5055c7__"